<template>
  <div class="home">
    <div class="header d-none d-sm-block">
      <FloatingLogo></FloatingLogo>
      <div class="header-slider"></div>
    </div>

    <div class="header mobile d-xs-block d-sm-none">
      <FloatingLogo></FloatingLogo>
      <div class="header-slider"></div>
    </div>

    <div class="body">
      <b-container class="search-form">
        <b-row class="location-row" align-h="center">
          <b-col col sm="8" md="6" lg="6">
            <b-form-select
                    id="city"
                    v-model="selectedState"
                    :options="this.$store.state.staticStates"
                    required
            ></b-form-select>
            <br />
          </b-col>
        </b-row>
        <b-row align-h="center">
          <b-button id="locate-me" @click="getLocation"
          >ó utiliza tu ubicación actual</b-button
          >
        </b-row>
        <b-row align-h="center">
          <b-button v-if="this.$store.state.selectedState == null" class="search-button" disabled>
            Buscar
          </b-button>
          <b-button v-else class="search-button" @click="continueToCategories">
            Buscar
            <span v-if="this.$store.state.selectedState != null"
            >en {{ this.$store.state.selectedState.name }}</span
            >
          </b-button>
          <br />
        </b-row>
      </b-container>

      <b-row align-h="center" class="boxed register-link-container">
        <b-col class="register-link-section-left col-3 col-sm-2 d-none d-sm-block">
        </b-col>
        <router-link to="/registro" col class="col-12 col-sm-8 register-link-section-center">
          <div class="register-link-title">¡Crezcamos juntos!</div>
          <div class="register-link">
            Registra gratis tu negocio o servicio haciendo click aquí
          </div>

        </router-link>
        <b-col class="register-link-section-right col-sm-2 d-none d-sm-block">
        </b-col>
      </b-row>

      <div class="bottom-spacer"></div>
      <Footer></Footer>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

import Footer from "@/components/Footer";
import FloatingLogo from "@/components/FloatingLogo";
export default {
  name: "Home",
  components: {
    FloatingLogo,
    Footer
    // HelloWorld
  },
  mounted() {
    this.selectedState = this.$store.state.selectedState;
  },
  data() {
    return {
      selectedState: null,
      selectedLocation: "",
      selectedCategory: ""
    };
  },
  watch: {
    // whenever question changes, this function will run
    selectedState: function(newState, oldState) {
      // console.log(`State changed from "${oldState}" to "${newState}"`);
      this.setSelectedState(newState);
    }
  },
  methods: {
    continueToCategories: function() {
      this.$router.push({
        name: "categories",
        params: {
          stateName: this.$store.state.selectedState.slug,
          state: this.$store.state.selectedState.id
        }
      });
    },
    getLocation: function() {
      //do we support geolocation
      if (!("geolocation" in navigator)) {
        this.errorStr = "Geolocation is not available.";
        return;
      }

      // this.gettingLocation = true;
      // get position
      navigator.geolocation.getCurrentPosition(
        pos => {
          // this.gettingLocation = false;
          // this.location = pos;
          console.log("Location is:", pos);

          const GET_CITY_FROM_COORDS_URL =
            `https://nominatim.openstreetmap.org/reverse?lat=${pos.coords.latitude}` +
            `&lon=${pos.coords.longitude}&format=json&addressdetails=1`;

          this.selectedLocation = pos.coords;

          this.$http
            .get(GET_CITY_FROM_COORDS_URL)
            .then(result => {
              const locationState = result.data.address.state;
              const selectedState = this.$store.state.staticStates.filter(
                state => state.text == locationState
              );

              if (selectedState.length < 1) {
                // fail
                this.selectedState = null;
                alert(`Lo sentimos pero por ahora la ubicación solo está disponible dentro de Venezuela.` +
                        ` Por favor contáctanos si deseas que agreguemos ${result.data.address.country} a nuestro sitio.`)
                console.error(
                  `La ubicación del usuarió está fuera del area de cobertura: ${locationState} - ${result.data.address.country}`
                );
              } else {
                this.selectedState = selectedState[0];
              }
            })
            .catch(error => {
              console.error(error);
            });
        },
        err => {
          // this.gettingLocation = false;
          this.errorStr = err.message;
          console.error(err);
        }
      );
    },
    setSelectedState: function(stateId) {
      this.$store.dispatch({
        type: "action",
        actionType: this.$types.SET_SELECTED_STATE,
        value: stateId
      });
    }
  }
};
</script>
